"use client";

import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

type AuthPasswordFieldProps = {
  label: string;
  name: string;
  autoComplete: string;
  minLength?: number;
};

export function AuthPasswordField({ label, name, autoComplete, minLength }: AuthPasswordFieldProps) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <label className="group block">
      <span className="mb-2 block text-[11px] font-bold uppercase tracking-[0.22em] text-black/55">
        {label}
      </span>
      <span className="flex h-14 items-center rounded-xl border border-black/10 bg-[#F6F1E3] transition-colors group-focus-within:border-[#A4243B]">
        <input
          data-sensitive
          name={name}
          type={isVisible ? "text" : "password"}
          minLength={minLength}
          required
          autoComplete={autoComplete}
          className="h-full min-w-0 flex-1 bg-transparent px-4 text-sm text-[#111] outline-none placeholder:text-black/35"
        />
        <button
          type="button"
          aria-label={isVisible ? "Jelszó elrejtése" : "Jelszó megjelenítése"}
          onClick={() => setIsVisible((current) => !current)}
          className="mr-3 grid h-9 w-9 place-items-center rounded-full text-black/45 transition hover:bg-black/5 hover:text-[#A4243B]"
        >
          {isVisible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </span>
    </label>
  );
}
